var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',{staticClass:"table"},[_c('tbody',_vm._l((_vm.amounts),function(value,key){return _c('tr',{attrs:{"v-key":key + value}},[_c('td',[_vm._v(_vm._s(key))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(value))])])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }